export const SAMPLE_LINE_SALES_DATA = [
  {
    "value": 1384,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 1257,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 1495,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 1234,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 1193,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 1202,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 1243,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 1403,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 1365,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 1343,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 1397,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 1399,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 1245,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 1290,
    "key": "2020-04-14T12:00:00"
  }
];

export const SAMPLE_LINE_REVENUE_DATA = [
  {
    "value": 13840,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 12570,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 14950,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 12340,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 11930,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 12020,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 12430,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 14030,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 13650,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 13430,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 13970,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 13990,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 12450,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 12900,
    "key": "2020-04-14T12:00:00"
  }
];

export const SAMPLE_SALES_SOURCE_1_DATA = [
  {
    "value": 867,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 355,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 1187,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 896,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 1162,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 1033,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 101,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 509,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 1199,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 96,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 660,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 1308,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 932,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 1057,
    "key": "2020-04-14T12:00:00"
  }
];

export const SAMPLE_SALES_SOURCE_2_DATA = [
  {
    "value": 1005,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 1032,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 1012,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 792,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 900,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 479,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 219,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 1051,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 490,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 342,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 153,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 1153,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 164,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 525,
    "key": "2020-04-14T12:00:00"
  }
];

export const SAMPLE_REVENUE_BY_SOURCE_1_DATA = [
  {
    "value": 8670,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 3550,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 11870,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 8960,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 11620,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 10330,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 1010,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 5090,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 11990,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 960,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 6600,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 13080,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 9320,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 10570,
    "key": "2020-04-14T12:00:00"
  }
];

export const SAMPLE_REVENUE_BY_SOURCE_2_DATA = [
  {
    "value": 10050,
    "key": "2020-04-01T12:00:00"
  },
  {
    "value": 10320,
    "key": "2020-04-02T12:00:00"
  },
  {
    "value": 10120,
    "key": "2020-04-03T12:00:00"
  },
  {
    "value": 7920,
    "key": "2020-04-04T12:00:00"
  },
  {
    "value": 9000,
    "key": "2020-04-05T12:00:00"
  },
  {
    "value": 4790,
    "key": "2020-04-06T12:00:00"
  },
  {
    "value": 2190,
    "key": "2020-04-07T12:00:00"
  },
  {
    "value": 10510,
    "key": "2020-04-08T12:00:00"
  },
  {
    "value": 4900,
    "key": "2020-04-09T12:00:00"
  },
  {
    "value": 3420,
    "key": "2020-04-10T12:00:00"
  },
  {
    "value": 1530,
    "key": "2020-04-11T12:00:00"
  },
  {
    "value": 11530,
    "key": "2020-04-12T12:00:00"
  },
  {
    "value": 1640,
    "key": "2020-04-13T12:00:00"
  },
  {
    "value": 5250,
    "key": "2020-04-14T12:00:00"
  }
];
